import { isProduction } from "utils/determineSite";

const UAT_ALLOY_URL = "https://icon-savings-plan-uat.app.alloy.com";
const PROD_ALLOY_URL = "https://icon-savings-plan.app.alloy.com";

export const getBaseAlloyUrl = () => {
  if (isProduction()) {
    return PROD_ALLOY_URL;
  }
  return UAT_ALLOY_URL;
};

export const getApplicationQueueForEntity = (entityName: string) => {
  if (isProduction()) {
    return `${PROD_ALLOY_URL}/v3/dashboard/journeys/applications/?filter=%7B%22journeyApplicationIsSandbox%22%3A%22false%22%2C%22journeyApplicationIsArchived%22%3A%22false%22%2C%22journeyType%22%3A%22application%22%7D&numRowsPerPage=20&pageNum=1&search=%7B%22childEntityName%22%3A%22${encodeURIComponent(
      entityName
    )}%22%7D&sort=%7B%7D`;
  } else {
    return `${UAT_ALLOY_URL}/v3/dashboard/journeys/applications/?filter=%7B%22journeyApplicationIsSandbox%22%3A%22true%22%2C%22journeyApplicationIsArchived%22%3A%22false%22%2C%22journeyType%22%3A%22application%22%7D&numRowsPerPage=20&pageNum=1&search=%7B%22childEntityName%22%3A%22${encodeURIComponent(
      entityName
    )}%22%7D&sort=%7B%7D`;
  }
};
